import { useAuthStore } from '@/store/auth';
import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';

export async function authGuard(
    to: RouteLocationNormalized,
    from: RouteLocationNormalized,
    next: NavigationGuardNext
): Promise<void> {
    const authStore = useAuthStore();
    
    try {
        // Initialize auth state from storage (mobile pattern)
        await authStore.initialize();
        
        const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
        const requiresGuest = to.matched.some(record => record.meta.requiresGuest);
        
        if (requiresAuth && !authStore.isAuthenticated) {
            // Redirect to login with return URL (mobile pattern)
            next({
                name: 'login',
                query: { redirect: to.fullPath }
            });
        } else if (requiresGuest && authStore.isAuthenticated) {
            // Redirect authenticated users away from guest-only pages
            next({ name: 'home' });
        } else {
            next();
        }
    } catch (error) {
        console.error('Auth guard error:', error);
        next({ name: 'login' });
    }
}

export async function initializeAuth(): Promise<void> {
    const authStore = useAuthStore();
    await authStore.initialize();
}
